export default __webpack_public_path__ + "static/media/casa.548c25ca.png";